import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./About.css";

export default function About() {
  return (
    <section id="about" className="about-section py-5">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <img
              src="https://media.istockphoto.com/id/1058737714/photo/bridge-in-hong-kong-and-container-cargo-freight-ship.webp?a=1&b=1&s=612x612&w=0&k=20&c=LSi2Wpwnhv4TcLanJLzdNkl3_0xH3StWUYRBH9vg1Mc="
              alt="VHATrade in action"
              className="img-fluid rounded shadow"
            />
          </Col>
          <Col md={6} className="mt-4 mt-md-0">
            <h2>About VHATrade</h2>
            <p>
              At VHATrade, we're more than an import–export business—we're a vital bridge between local suppliers and global markets. Based in Canada, we ensure the highest quality products reach worldwide clients with efficiency and care.
            </p>
            <ul className="about-list">
              <li>📈 **Personalized Trade Solutions** tailored to your industry's needs</li>
              <li>📦 **Rigorous Quality Control** to guarantee top-tier goods</li>
              <li>🌎 **Global Shipping Network**—efficient logistics and delivery</li>
              <li>🛠 **Compliance & Customs Expertise** to avoid delays</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

